export default class Constants {
	// TYPES
	static get TYPE_VR() {
		return "type_vr";
	}

	static get TYPE_WEBGL() {
		return "type_webgl";
	}

	static get TYPE_HTML5() {
		return "type_html5";
	}

	static get ANIMATION_INTERVAL_DELAY() {
		return 0.01;
	}

	static get IMAGE_PATH_PREFIX() {
		return "assets/img/";
	}

	static get VIDEO_PATH_PREFIX() {
		return "assets/video/";
	}
}



// WEBPACK FOOTER //
// ./src/Constants.js